/**
 * The various events that can be emitted from the module.
 */
export var HarmonyEvent;
(function (HarmonyEvent) {
    /**
     * Emitted when the Harmony instance is authenticated.
     */
    HarmonyEvent["AUTHENTICATED"] = "authenticated";
    /**
     * Emitted when there is an issue with authentication.
     */
    HarmonyEvent["AUTHENTICATION_ERROR"] = "authentication_error";
    /**
     * Emitted when content fails to play automatically due to the
     * browser's autoplay policy.
     */
    HarmonyEvent["AUTOPLAY_FAILED"] = "autoplay_failed";
    /**
     * Emitted when Harmony is about to disconnect.
     */
    HarmonyEvent["BEFORE_DISCONNECT"] = "before_disconnect";
    /**
     * Emitted when the volume is about to change.
     */
    HarmonyEvent["BEFORE_VOLUME_CHANGE"] = "before_volume_change";
    /**
     * Emitted after the segment has been buffered.
     */
    HarmonyEvent["BUFFERING_END"] = "buffering_end";
    /**
     * Emitted when a segment is being buffered.
     */
    HarmonyEvent["BUFFERING_START"] = "buffering_start";
    /**
     * Emitted when the Harmony instance has connected.
     */
    HarmonyEvent["CONNECTED"] = "connected";
    /**
     * Emitted when there is an error during connection.
     */
    HarmonyEvent["CONNECTION_ERROR"] = "connection_error";
    /**
     * Emitted when the list of devices in the user's Connect cluster changes.
     */
    HarmonyEvent["DEVICES_CHANGED"] = "devices_changed";
    /**
     * Emitted when the local device becomes inactive.
     */
    HarmonyEvent["DEVICE_DEACTIVATED"] = "device_deactivated";
    /**
     * Emitted when the local device's descriptor changes.
     */
    HarmonyEvent["DEVICE_DESCRIPTOR_CHANGED"] = "descriptor_changed";
    /**
     * Emitted when the Harmony instance has disconnected.
     */
    HarmonyEvent["DISCONNECTED"] = "disconnected";
    /**
     * Emitted when the duration of the current track has changed.
     */
    HarmonyEvent["DURATION_CHANGED"] = "duration_changed";
    /**
     * Emitted when an error ocurs.
     */
    HarmonyEvent["ERROR"] = "error";
    /**
     * Emitted when the last active device changes.
     */
    HarmonyEvent["LAST_ACTIVE_DEVICE_INFO_CHANGED"] = "last_active_device_info_changed";
    /**
     * Emitted when the local context ends due to an error.
     */
    HarmonyEvent["LOCAL_CONTEXT_ENDED"] = "local_context_ended";
    /**
     * Emitted if the local player is disabled.
     */
    HarmonyEvent["LOCAL_PLAYER_DISABLED"] = "local_player_disabled";
    /**
     * Emitted if the local player is enabled.
     */
    HarmonyEvent["LOCAL_PLAYER_ENABLED"] = "local_player_enabled";
    /**
     * Emitted when the local player is logged out remotely.
     */
    HarmonyEvent["LOCAL_PLAYER_LOGGED_OUT"] = "local_player_logged_out";
    /**
     * Emitted when the user logs out from all devices.
     */
    HarmonyEvent["LOGGED_OUT"] = "logged_out";
    /**
     * Emitted when a given threshold of errors has been reached for the current
     * context.
     */
    HarmonyEvent["MAX_LIST_ERRORS_REACHED"] = "max_list_errors_reached";
    /**
     * Emitted when the number of connections for a user has reached the maximum
     * allowed.
     */
    HarmonyEvent["MAX_SUBSCRIPTIONS_REACHED"] = "max_subscriptions_reached";
    /**
     * Emitted when the user's playback session is capped.
     */
    HarmonyEvent["PLAYBACK_CAPPED"] = "playback_capped";
    /**
     * Emitted when the local player has been initialized correctly.
     *
     * Clients need to wait until Event.LOCAL_PLAYER_ENABLED is emitted before
     * trying to target the local player.
     */
    HarmonyEvent["PLAYER_INITIALIZATION_DONE"] = "player_initialization_done";
    /**
     * Emitted when Harmony cannot instantiate a local player object due to
     * errors in the platform.
     */
    HarmonyEvent["PLAYER_INITIALIZATION_FAILED"] = "player_initialization_failed";
    /**
     * Emitted when the current user's product state changes.
     */
    HarmonyEvent["PRODUCT_STATE_CHANGED"] = "product_state_changed";
    /**
     * Emitted periodically while an item is playing to signal progress within
     * the item.
     */
    HarmonyEvent["PROGRESS"] = "progress";
    /**
     * Emitted when the queue window has changed.
     */
    HarmonyEvent["PLAYER_QUEUE_CHANGED"] = "player_queue_changed";
    /**
     * Emitted when the Harmony instance has been reconnected.
     */
    HarmonyEvent["RECONNECTED"] = "reconnected";
    /**
     * Emitted when the Harmony instance is reconnecting.
     */
    HarmonyEvent["RECONNECTING"] = "reconnecting";
    /**
     * Emitted if local observation is disabled.
     */
    HarmonyEvent["REMOTE_OBSERVER_DISABLED"] = "remote_observer_disabled";
    /**
     * Emitted if local observation is enabled.
     */
    HarmonyEvent["REMOTE_OBSERVER_ENABLED"] = "remote_observer_enabled";
    /**
     * Emitted if an error occurs during service registration.
     */
    HarmonyEvent["SERVICE_REGISTRATION_ERROR"] = "service_registration_error";
    /**
     * Emitted when the PlaybackState changes.
     */
    HarmonyEvent["STATE_CHANGED"] = "state_changed";
    /**
     * Emitted when the playback is stopped due to the application going into
     * background.
     */
    HarmonyEvent["STOPPED_ON_BACKGROUND"] = "stopped_on_background";
    /**
     * Emitted when the current track ends.
     */
    HarmonyEvent["TRACK_ENDED"] = "track_ended";
    /**
     * Emitted when an error occurs that prevents Harmony from continuing normal
     * operation.
     */
    HarmonyEvent["UNRECOVERABLE_FAILURE"] = "unrecoverable_failure";
    /**
     * Emitted when the video element has been appended to the area
     * designated by the application.
     */
    HarmonyEvent["VIDEO_ELEMENT_APPENDED"] = "video_element_appended";
    /**
     * Emitted when the video element has been removed from the area
     * designated by the application.
     */
    HarmonyEvent["VIDEO_ELEMENT_REMOVED"] = "video_element_removed";
})(HarmonyEvent || (HarmonyEvent = {}));
//# sourceMappingURL=harmony_event.js.map